import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: theme.colorPalette.green_90,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  rejection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: '100%',
    gap: theme.spacing(2),
    borderTop: `1px solid ${theme.onCardDivider.green_80}`,
    marginBottom: theme.spacing(2)
  },
  inside: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    maxWidth: 880,
    margin: theme.spacing(2, 0, 0, 0)
  },
  topRow: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
    width: '100%'
  },
  button: {
    borderRadius: '100%',
    height: 32,
    width: 32,
    padding: 0
  },
  row: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center'
  },
  titleColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1)
  },
  code: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 600,
    color: theme.colorPalette.orange_75
  },
  title: {
    color: theme.onCard.white,
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 600
  },
  subtitle: {
    textAlign: 'left',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.onCard.beige_25
  },
  branchPlusEligible: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.colorPalette.green_80,
    color: theme.onCard.beige_25,
    borderRadius: theme.spacing(4),
    padding: theme.spacing(0, 2),
    height: 26,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 600,
    ...reskinStyles(theme, theme.labelStyles.outlined)
  },
  iconRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    fontSize: 10,
    fontWeight: 600,
    lineHeight: '12px',
    color: theme.onCard.white
  },
  subBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    border: `2px solid ${theme.onCardDivider.green_80}`,
    borderRadius: 4,
    padding: theme.spacing(2),
    gap: theme.spacing(2)
  },
  icon: {
    marginRight: theme.spacing(1)
  },
  boxContent: {
    textAlign: 'left',
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 400,
    color: theme.onCard.white
  },
  rotateIcon: {
    transform: 'rotate(180deg)'
  },
  overrideButton: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: 24
  }
});

export default makeStyles(styles);
